(function () {
    'use strict';

    angular
        .module('localization')
        .config(config);

    function config($translateProvider) {

        var data = {
            // http://www.xe.com/ibancalculator/sample/?ibancountry=croatia
            session: {
              inactiveUser: 'Zbog neaktivnosti isteklo Vam je vrijeme za rad u aplikaciji. Molimo prijavite se ponovo.'
            },
            common: {
	            "fileUploadLimit": "Datoteka {{fileName}} je veća od maksimalne dozvoljene veličine {{maxSize}}",
              loadMore: 'Učitaj još',
              loadLess: 'Smanji',
              required: 'Obavezan unos',
              and: ' i '
            },
            core: {
              'gdpr.title': 'Važno!',
              'gdpr.info': 'Radi pružanja veće sigurnosti i sprečavanja prijevara, Addiko Bank d.d. nadogradila je Addiko eBank aplikaciju s dodatnim sigurnosnim komponentama koje omogućuju prepoznavanje sumnjivih aktivnosti temeljenih na ponašanju korisnika i tehničkim podacima o uređaju. U svrhu prevencije prijevara i izgradnje sigurnosnog profila korisnika, tijekom korištenja usluge mogu se prikupljati tehnički podaci o uređaju i internetskom pregledniku (uključujući operativni sustav, vrstu i verziju preglednika, razlučivost zaslona, jezične postavke i IP adresu), kao i podaci o ponašanju korisnika unutar aplikacije, poput načina unosa putem tipkovnice, pomicanja miša, te uobičajenih aktivnosti korisnika. Ovisno o vrsti eventualno detektirane sumnjive aktivnosti bit će Vam ograničen ili onemogućen rad u aplikaciji. <br><br> Dodatne informacije o obradi Vaših osobnih podataka možete vidjeti na sljedećoj poveznici <a href="{{gdprAssetLink}}" class="text-underline" target="_blank">ovdje</a> <br><br>Odabirom gumba Nastavi potvrđujete da ste suglasni s navedenim uvjetima.',
              'continue': 'Nastavi',
              'giveUp': 'Odustani',
              'newNotificationsTitle': 'Poštovani,<br><br>imate dostupno {{messages}} novih poruka u vašem pretincu, {{statements}} izvoda po računima i {{documents}} dokumenata. <br> Provjerite ih čim prije kako ne biste propustili bitne obavijesti.<br><br>Addiko Bank',
              'addDocument': 'Dodajte dokument',
              "filter": {
                maxDateRange: "Maksimalni raspon datuma je jedna godina."
              },
                "inputFields": {
                    IBAN: "9999 9999 9999 9999 9"
                },
                "moneyFormat": {
                    mask: "#.###.##0,00",
                    placeholder: "eg: 000.000,00"
                },
                "period": {
                    today: "Danas",
                    yesterday: "Jučer",
                    thisWeek: "Sedam dana",
                    thisMonth: "Mjesec dana",
                    thisYear: "Godina dana",
                    all: "Sve",
                    allMessages: "Sve poruke"
                },
                "paymentOrder": "Nalog broj",
                "investOrder": "Investicija broj",
                "ebookOrder": "eKnjižica broj",
                "successDelete": "je uspješno izbrisan.",
                "investSuccessDelete": "je uspješno izbrisana.",
                "termDepositPayoutType": {
                    "2": "Pripis kamate po dospijeću",
                    "2e": "(kamata i glavnica zajedno)",
                    "16": "Mjesečna isplata kamate na dan",
                    "16e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakog 15 u mjesecu)",
                    "17": "Tromjesečna isplata kamate na dan",
                    "17e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svaka tri mjeseca 15 u mjesecu)",
                    "18": "Šestomjesečna isplata kamate na dan",
                    "18e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih šest mjeseci 15 u mjesecu)",
                    "19": "Godišnja isplata kamate na dan",
                    "19e": "(pojašnjenje: ako se oročenje ugovori npr. na 15, isplata kamate je svakih godinu dana 15 u mjesecu)",
                    "3": "Isplata kamate po dospijeću",
                    "3e": "(samo kod automatskog produženja)"

                },
              "termDepositStatus": {
                "realised": "Realiziran",
                "unrealised": "Neostvaren",
                "cancelled": "Otkazan",
                "receivednotexecuted":"U obradi"
              },
              "confirmation": "Reklamacija na transakciju je uspješno zaprimljena u bazu podataka.",
              "error": "Greška",
              sweetAlertTranslation: {
                yes: "Da",
                no: "Ne",
                areYouSure: "Jeste li sigurni?"
              },
              logoutModalTranslation: {
                logoutBtn: "Da",
                logoutMsg: "Jeste li sigurni da se želite odjaviti ?",
                "cancel":"Ne"
              },
              "sameAccounts": "Greška: Isti računi!",
              paymentSignedStatus:{
                  "InProcessing":"U obradi"
              },
              "today":"Danas",
              "noAccounts": "Nema dostupnih računa",
              datePicker: {
                "doneBtn":"Uredu",
                "clearBtn":"Obriši"
              }
            }
        };

        $translateProvider
            .translations('hr', data);

    }
}());
